export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14942.e1569225.jpg";